function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_242",
  "data-name": "Group 242",
  transform: "translate(10 10)"
}, /*#__PURE__*/React.createElement("path", {
  id: "location",
  d: "M0,7.9A7.462,7.462,0,0,1,7.9,0a7.915,7.915,0,0,1,7.9,7.9q0,3.617-6.626,9.885a1.952,1.952,0,0,1-2.613.063Q0,12.216,0,7.9Zm7.9,1.58A2.633,2.633,0,1,0,5.265,6.845,2.633,2.633,0,0,0,7.9,9.478Z",
  transform: "translate(3.182 1.842)",
  fill: "#5351fb"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_115",
  "data-name": "Rectangle 115",
  width: 22,
  height: 22,
  transform: "translate(0.001)",
  fill: "none"
}));

var SvgBranchLocation = function SvgBranchLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_248",
    "data-name": "Group 248",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBranchLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/branch-location.1ba2f89e.svg";
export { ForwardRef as ReactComponent };